import { render, staticRenderFns } from "./selectClass.vue?vue&type=template&id=05e57c42&scoped=true&"
import script from "./selectClass.vue?vue&type=script&lang=js&"
export * from "./selectClass.vue?vue&type=script&lang=js&"
import style0 from "./selectClass.vue?vue&type=style&index=0&id=05e57c42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e57c42",
  null
  
)

export default component.exports